"use client";

import React from "react";
import { AudioWaveform, Download, Music, PenTool } from "lucide-react";
import { Card, CardDescription, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "AI 逐句拆解",
  desc: "支持字幕文件和智能识别音频内容，将长难句自动切分为短句，让练习更有针对性。",
  icon: AudioWaveform,
  color: "bg-[#E7F8ED]"
}, {
  title: "中英对照",
  desc: "实时同步精准翻译，双语对照理解，彻底告别“听天书”的焦虑感。",
  icon: PenTool,
  color: "bg-[#FFFBE6]"
}, {
  title: "循环精听",
  desc: "锁定单句无限循环，直到听清每一个发音细节，攻克所有听力盲点。",
  icon: Music,
  color: "bg-[#E6F7FF]"
}, {
  title: "智能记忆复习",
  desc: "结合 Anki 科学算法，自动管理生词难句，让听力进步稳扎稳打。",
  icon: Download,
  color: "bg-[#F9F0FF]"
}];
export default function CoreFeatures() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="90523" id="智慧功能如虎添翼" className="bg-[#F7F7F7] text-[#4B4B4B] py-24 px-4 md:px-8 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#58CC02]/5 rounded-full blur-[120px] pointer-events-none" />

      {}
      <svg width="0" height="0" className="absolute hidden">
        <defs>
          <linearGradient id="icon-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop stopColor="#58CC02" offset="0%" />
            <stop stopColor="#1CB0F6" offset="100%" />
          </linearGradient>
        </defs>
      </svg>

      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-6 tracking-tight text-[#4B4B4B]">
            智慧功能，<span className="text-transparent bg-clip-text bg-gradient-to-r from-[#58CC02] to-[#1CB0F6]">如虎添翼</span>
          </h2>
          <p className="text-[#4B4B4B]/70 text-lg md:text-xl max-w-2xl mx-auto font-medium">
            融合前沿 AI 技术，为你打造沉浸式的精听环境，让每一次练习都能真正听懂。
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((item, i) => {
          const Icon = item.icon;
          return <div key={i} data-index={i} className="group relative rounded-[24px] p-[1px] transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl hover:shadow-[#58CC02]/10">
                {}
                <div className="absolute inset-0 rounded-[24px] bg-[#E5E5E5] group-hover:bg-gradient-to-br group-hover:from-[#58CC02] group-hover:to-[#1CB0F6] transition-colors duration-500" />
                
                <Card className={`relative h-full ${item.color} backdrop-blur-xl border-0 rounded-[24px] flex flex-col items-center text-center p-8 shadow-none overflow-hidden`}>
                  {}
                  <div className="absolute inset-0 bg-gradient-to-b from-white/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                  
                  <div className="mb-8 p-5 rounded-2xl bg-white shadow-sm border border-[#E5E5E5] group-hover:border-[#58CC02]/30 transition-colors duration-500 relative">
                    <div className="absolute inset-0 bg-gradient-to-br from-[#58CC02]/10 to-[#1CB0F6]/10 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                    <Icon className="w-10 h-10 relative z-10 transition-transform duration-500 group-hover:scale-110" stroke="url(#icon-gradient)" strokeWidth={2} />
                  </div>
                  
                  <CardTitle className="text-xl font-bold mb-4 text-[#4B4B4B] tracking-wide">
                    {item.title}
                  </CardTitle>
                  
                  <CardDescription className="text-[#4B4B4B]/80 text-base leading-relaxed font-medium">
                    {item.desc}
                  </CardDescription>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}